import { Stack, Text, Code } from '@mantine/core';
import type { TSearchResultMatch } from '@newo/api/gateway';
import { MAX_VISIBLE_MATCHES } from '@/components/SearchResultsContent/SearchResultsContent.constants';

interface MatchesListProps {
    matches: TSearchResultMatch[];
}

export const MatchesList = ({ matches }: MatchesListProps) => {
    if (matches.length === 0) {
        return;
    }

    return (
        <div>
            <Text c="dimmed" mb="xs" size="xs">
                Matches found in:
            </Text>
            <Stack gap="xs">
                {matches
                    .slice(0, MAX_VISIBLE_MATCHES)
                    .map((match, matchIndex) => (
                        <div key={matchIndex}>
                            <Text c="dimmed" fw={600} size="xs">
                                {match.search_field}:
                            </Text>
                            <Code block className="text-xs">
                                {match.search_value}
                            </Code>
                        </div>
                    ))}
                {matches.length > MAX_VISIBLE_MATCHES && (
                    <Text c="dimmed" size="xs">
                        ... and {matches.length - MAX_VISIBLE_MATCHES} more
                        matches
                    </Text>
                )}
            </Stack>
        </div>
    );
};
